import styled from 'styled-components';
import { WHITE, LOW_WHITE, MAIN_BLUE } from '../../styles/Colors';
import { above, below } from '../../utils/Breakpoints';

export const HeaderContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 1920px;
  height: 80px;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  position: fixed;
  z-index: 999;
  margin-bottom: 150px;
  background-color: white;
  padding: 0 100px;
  @media (max-width: 1080px) {
    justify-content: flex-start;
    padding: 0px 10px;
  }
`;

export const HeaderBrand = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderLogo = styled.img`
  height: 95%;
  max-width: 50px;
`;
export const HeaderMainTitle = styled.h1`
  display: flex;
  flex-direction: column;
  margin: 0;
  margin-left: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 38px;
  line-height: 1.2;
  & > span {
    font-size: 24px;
  }
`;

export const HeaderNavigation = styled.ul`
  display: flex;
  align-items: center;
  ${below.large`padding: 15px;
    flex-direction: column;
    position: absolute;
    background: ${MAIN_BLUE};
    margin: 0;
    top: 120px;
    color: ${WHITE};
    right: -150%;
    transition: all 0.5s;
      `}
`;

export const HeaderNavigationButton = styled.a`
  padding: 5px 20px;
  font-size: 22px;
  border-left: ${(props) => (props.hasSeparators ? '1px solid black' : null)};
  border-right: ${(props) => (props.hasSeparators ? '1px solid black' : null)};
  border-radius: 3px;
  transition: 0.2s;
  &:hover {
    transition: 0.2s;
    background-color: ${LOW_WHITE};
  }

  ${above.med`
    padding: 0;
    padding: 15px 30px 15px 10px;

    border: none;
    &:hover {
      transition: inherit;
      color: ${LOW_WHITE};
      background: none;
    }
    `}
`;
export const BarsMenuButton = styled.img`
  width: 30px;
  height: auto;
  cursor: pointer;
  position: absolute;
  right: 20px;
  z-index: 1000;

  ${above.large`
    display:none;`}
`;

export const CheckBarsMenu = styled.input`
  display: none;
  &:checked ~ ${HeaderNavigation} {
    right: 0;
  }
`;

export const NavigationIcon = styled.label`
  line-height: 120px;
  align-self: center;
`;
